import React, { useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { HeaderLogin } from './template/index';
import api from '../services/api';
import { Error } from './Alert/index';

export default function Login () {
  const history = useHistory();
  const [error, setError] = useState(false);
  const [validated, setValidated] = useState(false);
  const [values, setValues] = useState({
    email: '',
    password: '',
  });

  function handleChangeValues (event) {
    setValues({ ...values, [event.target.name]: event.target.value });
  }

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      api.post('/sessions', {
        email: values.email,
        password: values.password,
      })
        .then((res) => {
          api.defaults.headers.common.realm = res.data.realm;
          localStorage.setItem('realm', res.data.realm);
          localStorage.setItem('logged', res.data.logged);
          history.push('/');
        })
        .catch((err) => {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = err.response.data.error;
          setTimeout(() => setError(false), 3000);
        });
    }

    setValidated(true);
  };
  return (
    <>
      <HeaderLogin />
      <div className="content">
        {error ? <Error><p id="msgError" /></Error> : null}
        <Card style={{ width: '25rem' }}>
          <Card.Header className="text-bold">Campus Conectado - Login</Card.Header>
          <Card.Body>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Group controlId="validationEmail">
                <Form.Label>E-mail</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={values.email}
                  onChange={handleChangeValues}
                  placeholder="Entre com seu e-mail"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Por favor entre com o e-mail.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="validationPassword">
                <Form.Label>Senha</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  value={values.password}
                  onChange={handleChangeValues}
                  placeholder="Entre com sua senha"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Por favor entre com a senha.
                </Form.Control.Feedback>
              </Form.Group>
              <Button className="text-bold" block type="submit" variant="info">Login</Button>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </>
  );
}
